import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';
import { omit, pick } from 'lodash';
import MediaFile from 'models/core/mediaFile/Model.MediaFile';
import Model from 'models/Model';

export async function documentTranslationSaveApi(body?: Api.Core.DocumentTranslation.Save.IRequest) {
  const serverResponse = await executeServerApi<
    Api.Core.DocumentTranslation.Save.IRequest,
    Api.Core.DocumentTranslation.Save.IResponse,
    Api.Core.DocumentTranslation.Save.IHeaders
  >({
    method: body?.id ? HttpMethod.put : HttpMethod.post,
    url: '/api/Localization/DocumentTranslation',
    body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
export async function documentTranslationListApi(
  body?: Api.Core.DocumentTranslation.List.IRequest & Api.Core.DocumentTranslation.List.IParams
) {
  return await executeServerApi<
    Api.Core.DocumentTranslation.List.IRequest,
    Api.Core.DocumentTranslation.List.IResponse,
    Api.Core.DocumentTranslation.List.IHeaders
  >({
    method: HttpMethod.get,
    url: createPathFromRoute('/api/Localization/DocumentTranslation/:documentType', pick(body, 'documentType')),
    body: omit(body, 'documentType'),
    headers: getDefaultHeaders(),
  });
}
export async function documentTranslationDeleteApi(body: Api.Core.DocumentTranslation.Delete.IRequest) {
  const serverResponse = await executeServerApi<
    Api.Core.DocumentTranslation.Delete.IRequest,
    Api.Core.DocumentTranslation.Delete.IResponse,
    Api.Core.DocumentTranslation.Delete.IHeaders
  >({
    method: HttpMethod.delete,
    url: createPathFromRoute('/api/Localization/DocumentTranslation/:id', body),
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
export default class DocumentTranslation
  extends Model<Model.IDocumentTranslation>({ icon: 'fas-cloud' })
  implements Model.Instance<Model.IDocumentTranslation>
{
  id: number;
  documentId: number;
  documentType: Utils.DocumentLocalizationType;
  languageIsoCode: Locale.Languages;
  mediaFileId: number;
  mediaFile: MediaFile;

  constructor(
    data: Partial<Model.IDocumentTranslation> | Utils.FormData<Model.IDocumentTranslation>,
    language?: Locale.Languages
  ) {
    super(
      {
        mediaFile: MediaFile,
      },
      language
    );
    this.update(data);
  }
  get displayInfo(): Model.DisplayInfo {
    return {
      id: this.id,
      title: this.documentType || this.id?.toString(),
    };
  }

  static async list(body?: Api.Core.DocumentTranslation.List.IRequest & Api.Core.DocumentTranslation.List.IParams) {
    const { payload, ...rest } = await documentTranslationListApi(body);
    return {
      ...rest,
      payload: payload && {
        data: payload.data?.map((it) => new DocumentTranslation(it)),
        count: payload.count,
      },
    };
  }
  async save() {
    return await documentTranslationSaveApi(this);
  }
  async delete() {
    return await documentTranslationDeleteApi({ id: this.id });
  }
}
